import { createDeletablePermission } from "@/permissions/shared/createDeletablePermission";
import { useMeetingsStore } from "@/stores/meetingsStore";

export function useMeetingPermissions() {
  const store = useMeetingsStore();

  const deletable = createDeletablePermission(store);

  return { deletable };
}
